export default "__VITE_ASSET__CY8hS3V3__"